import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICON_TYPE, IconModule } from "@spartacus/storefront";
import { SafeModule } from 'src/app/generac/shared/pipes/safe/safe.module';

@Component({
    selector: 'gen-no-return-warning',
    templateUrl: './no-return-warning.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      IconModule,
      SafeModule
    ],
})
export class GenNoReturnWarningComponent {
  @Input() color: string;
  @Input() message: string;
  iconTypes = ICON_TYPE;
}
